module.exports = __webpack_public_path__ + "img/Frame 37.02b7e9eb.svg";